module.exports = __webpack_public_path__ + "static/img/iSMART.66de6eb6.png";